"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var useTabTrigger_exports = {};
__export(useTabTrigger_exports, {
  shouldHandleMouseEvent: () => shouldHandleMouseEvent,
  useTabTrigger: () => useTabTrigger
});
module.exports = __toCommonJS(useTabTrigger_exports);
var import_react = require("react");
var import_getPathFromState_mods = require("../fork/getPathFromState-mods");
var import_imperative_api = require("../router/imperative-api");
var import_matchers = require("../router/matchers");
var import_Navigator = require("../views/Navigator");
var import_TabContext = require("./TabContext");
function shouldHandleMouseEvent(event) {
  if (!event) return true;
  if ("button" in event) {
    return !event.metaKey && !event.altKey && !event.ctrlKey && !event.shiftKey && (event.button == null || event.button === 0) && [
      void 0,
      null,
      "",
      "self"
    ].includes(event.currentTarget.target);
  }
  return true;
}
function useTabTrigger(options) {
  var { state, navigation } = (0, import_Navigator.useNavigatorContext)();
  var { name, resetOnFocus, onPress, onLongPress } = options;
  var triggerMap = (0, import_react.use)(import_TabContext.TabTriggerMapContext);
  var getTrigger = (0, import_react.useCallback)(function(name2) {
    var config = triggerMap[name2];
    if (!config) return;
    return {
      isFocused: state.index === config.index,
      route: state.routes[config.index],
      resolvedHref: (0, import_matchers.stripGroupSegmentsFromPath)((0, import_getPathFromState_mods.appendBaseUrl)(config.href)),
      ...config
    };
  }, [
    triggerMap,
    state
  ]);
  var trigger = name !== void 0 ? getTrigger(name) : void 0;
  var switchTab = (0, import_react.useCallback)(function(name2, options2) {
    var config = triggerMap[name2];
    if (config) {
      if (config.type === "external") {
        return import_imperative_api.router.navigate(config.href);
      }
      return navigation === null || navigation === void 0 ? void 0 : navigation.dispatch({
        ...config.action,
        type: "JUMP_TO",
        payload: {
          ...config.action.payload,
          ...options2
        }
      });
    }
    return navigation === null || navigation === void 0 ? void 0 : navigation.dispatch({
      type: "JUMP_TO",
      payload: {
        name: name2
      }
    });
  }, [
    navigation,
    triggerMap
  ]);
  var handleOnPress = (0, import_react.useCallback)(function(event) {
    onPress === null || onPress === void 0 ? void 0 : onPress(event);
    if (!trigger || (event === null || event === void 0 ? void 0 : event.isDefaultPrevented())) return;
    navigation === null || navigation === void 0 ? void 0 : navigation.emit({
      type: "tabPress",
      target: trigger.type === "internal" ? trigger.route.key : trigger.href,
      canPreventDefault: true
    });
    if (!shouldHandleMouseEvent(event) || trigger.isFocused) return;
    switchTab(name, {
      resetOnFocus
    });
  }, [
    onPress,
    name,
    resetOnFocus,
    trigger,
    navigation,
    switchTab
  ]);
  var handleOnLongPress = (0, import_react.useCallback)(function(event) {
    onLongPress === null || onLongPress === void 0 ? void 0 : onLongPress(event);
    if (!trigger || (event === null || event === void 0 ? void 0 : event.isDefaultPrevented())) return;
    navigation === null || navigation === void 0 ? void 0 : navigation.emit({
      type: "tabLongPress",
      target: trigger.type === "internal" ? trigger.route.key : trigger.href
    });
    if (!shouldHandleMouseEvent(event)) return;
    switchTab(name, {
      resetOnFocus
    });
  }, [
    onLongPress,
    name,
    resetOnFocus,
    trigger,
    navigation,
    switchTab
  ]);
  return {
    switchTab,
    getTrigger,
    trigger,
    triggerProps: {
      isFocused: Boolean(trigger === null || trigger === void 0 ? void 0 : trigger.isFocused),
      onPress: handleOnPress,
      onLongPress: handleOnLongPress
    }
  };
}
//# sourceMappingURL=useTabTrigger.js.map
